"use client";
import { jsxs as n, jsx as l } from "react/jsx-runtime";
const t = ({
  title: a,
  titleId: i,
  desc: e,
  descId: r,
  ...d
}) => /* @__PURE__ */ n(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 22 20",
    "aria-hidden": "true",
    "data-slot": "icon",
    width: 24,
    height: 24,
    "aria-labelledby": i,
    "aria-describedby": r,
    ...d,
    children: [
      e ? /* @__PURE__ */ l("desc", { id: r, children: e }) : null,
      a ? /* @__PURE__ */ l("title", { id: i, children: a }) : null,
      /* @__PURE__ */ n("g", { fill: "currentColor", children: [
        /* @__PURE__ */ l("path", { d: "m9.5248 1.5618.2406-.2405A.7684.7684 0 1 0 8.6787.2346l-1.537 1.537a.7685.7685 0 0 0 0 1.0867l1.537 1.537a.7685.7685 0 0 0 1.0867-1.0867l-.2083-.2082a6.912 6.912 0 0 1-.335 13.8161H.7684a.7686.7686 0 0 0 0 1.537h8.4536a8.4481 8.4481 0 0 0 .3027-16.8917M21.293 17.1417l-1.5371-1.537a.7684.7684 0 0 0-1.0866 1.0867l.2251.2251h-2.7558a.7686.7686 0 0 0 0 1.537h2.7558l-.2251.2252a.768.768 0 0 0-.0095 1.0962.768.768 0 0 0 .55.2251.769.769 0 0 0 .5461-.2346l1.5371-1.537a.769.769 0 0 0 0-1.0867" }),
        /* @__PURE__ */ l("path", { d: "M3.0825 15.3795a.768.768 0 0 0 .6874-.4248.769.769 0 0 0-.0725-.8048 6.84 6.84 0 0 1-1.3918-4.15 6.917 6.917 0 0 1 3.4582-5.9812.7691.7691 0 1 0-.7684-1.3326A8.459 8.459 0 0 0 .7686 10a8.364 8.364 0 0 0 1.6991 5.0721.7692.7692 0 0 0 .6148.3074" })
      ] })
    ]
  }
);
export {
  t as default
};
